import { css } from "styled-components";
import theme from "../../../../theme";

const commonInputCss = css`
  padding: 8px 12px;
  width: 100%;
  border-radius: var(--radius-md);

  :focus,
  :focus-visible,
  :focus-within {
    outline: none;

    border-color: var(--color-slate-500);

    --tw-ring-color: var(--color-slate-300);
    --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0
      calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);

    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow),
      var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }

  ${(props) =>
    props.maxWidth &&
    css`
      max-width: ${(props) => props.maxWidth};
    `}
`;

export const StyledInputTemplate = css`
  ${commonInputCss};
  background-color: ${(props) => props.theme.colors.white};
  border: 1px solid
    ${(props) =>
      props.hasError || props.haserror
        ? "var(--color-destructive)"
        : "var(--color-edge)"};
  box-shadow: none;
  transition:
    border-color ease-in-out 0.5s,
    box-shadow ease-in-out 0.5s;
  transition-duration: 0.5s;
  outline: none;

  :disabled {
    background-color: ${(props) =>
      props.legacyMode ? "#EEEEEE" : props.theme.colors.disabled};
  }

  ::placeholder {
    color: var(--color-slate-400);
  }

  ::selection {
    background-color: #42a5f5;
    color: ${(props) => props.theme.colors.white};
  }

  ${(props) =>
    props.inputStyle === "v2" &&
    css`
      :disabled {
        background-color: transparent;
        border-color: ${(props) => props.theme.colors.white};
      }

      ::placeholder {
        color: ${(props) => props.theme.colors.white};
      }
    `}
`;

export const StyledTransparentInputTemplate = css`
  ${commonInputCss};
  background-color: transparent;
  border: none;
  outline: none;
  padding: 0;

  ::placeholder {
    color: ${theme.colors.placeholder};
  }
`;
